import { Card, Col, Form, Row } from "react-bootstrap";
import ESBarGraph from "../../controls/ESBarGraph";
import ESSearchDropdown from "../../controls/ESSearchDropdown";
import { useContext, useEffect, useState } from "react";
import { axiosPost } from "../../utils/AxiosHelper";
import { getFormResponseAnalysis } from "../../utils/ApiUrl";
import { FormProvider, useForm } from "react-hook-form";
import { UserContext } from "../../routes/routes";
import { Option } from "../../utils/common";

interface Props {
  selectedSurvey: any;
  setSelectedSurvey: any;
  isSurveySelected: any;
}

interface IFormResponseAnalysisDetail {
  QuestionTitle: string;
  SurveyQuestionResponseDetails: string;
}

interface EmployeeEngagementInfo {
  Title: string;
  Count: number;
}

export default function FormInfoBarChart(props: Props) {
  const { selectedSurvey, setSelectedSurvey, isSurveySelected } = props;
  const { appContextdata, setAppContextdata } = useContext<any>(UserContext);
  const [formResponseQuestions, setFormResponseQuestions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isQuestionSelected, setIsQuestionSelected] = useState(false);
  const [selectedFormResponseQuestion, setSelectedFormResponseQuestion] =
    useState<any>();
  const [formResponseAnalysisDetails, setFormResponseAnalysisDetails] =
    useState<IFormResponseAnalysisDetail[]>([]);
  const [
    selectedSurveyQuestionResponseDetails,
    setSelectedSurveyQuestionResponseDetails,
  ] = useState<EmployeeEngagementInfo[]>([]);
  const methods = useForm<any>({
    defaultValues: {
      FormResponseQuestion: null,
    },
  });

  useEffect(() => {
    setFormResponseAnalysisDetails([]);
    setFormResponseQuestions([]);
    setSelectedSurveyQuestionResponseDetails([]);
    setSelectedFormResponseQuestion({});
    setIsQuestionSelected(false);
    fetchDataForOrganization();
  }, [selectedSurvey]);

  const fetchDataForOrganization = async () => {
    if(selectedSurvey?.value > 0){
      await fetchDashboardStatisticsInfo(selectedSurvey?.value);
    }
  };

  const handleQuestionChange = async (value: Option | null) => {
    if (value) {
      setIsQuestionSelected(true);
      setSelectedFormResponseQuestion(value);
      let updatedResponse = formResponseAnalysisDetails?.find(
        (item: IFormResponseAnalysisDetail) =>
          item?.QuestionTitle === (value?.value ?? "").toString()
      );
      if (updatedResponse) {
        setSelectedSurveyQuestionResponseDetails(
          JSON.parse(updatedResponse?.SurveyQuestionResponseDetails)
        );
      }
    } else {
      setIsQuestionSelected(false);
      setSelectedFormResponseQuestion({});
      setSelectedSurveyQuestionResponseDetails([]);
      methods.reset({
        SurveyAssignmentId: null,
      });
    }
  };

  const fetchDashboardStatisticsInfo = async (
    SurveyAssignmentId: number | null
  ) => {
    setLoading(true);
    try {
      const response: any = await axiosPost(getFormResponseAnalysis, {
        OrganizationId: appContextdata?.Organization || 0,
        SurveyAssignmentId: SurveyAssignmentId || 0,
      });
      const data = response?.data?.ExtraData?.formQuestionResponseAnalyses || [];
      if (data?.length > 0) {
        let FormResponseQuestionList = data?.map(
          (item: IFormResponseAnalysisDetail) => ({
            label: item?.QuestionTitle,
            value: item?.QuestionTitle,
          })
        );
        setFormResponseQuestions(FormResponseQuestionList);

        let FirstData = data[0];
        setSelectedFormResponseQuestion({
          label: FirstData?.QuestionTitle,
          value: FirstData?.QuestionTitle,
        });
        setIsQuestionSelected(true);
        setSelectedSurveyQuestionResponseDetails(
          JSON.parse(FirstData?.SurveyQuestionResponseDetails)
        );
      }
      setFormResponseAnalysisDetails(data);
    } catch (error) {
      console.error("Error fetching dashboard statistics:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {isSurveySelected && formResponseQuestions?.length > 0 ? (
        <div className="employee-engagement-chart">
          <Row>
            <Col lg="12" md="12" xs="12">
              <Card className={`grey-color`}>
                <div className="card-content">
                  <Row>
                    <Col md="4"></Col>
                    <FormProvider {...methods}>
                      <Form.Group as={Col} md="2">
                        <Form.Label className="mt-1 d-none">
                          Select Question
                        </Form.Label>
                      </Form.Group>
                      <Form.Group as={Col} md="6">
                        <ESSearchDropdown
                          name="FormResponseQuestion"
                          placeholder="Form Response Question"
                          options={formResponseQuestions}
                          defaultValue={formResponseQuestions[0]}
                          value={selectedFormResponseQuestion}
                          onChange={handleQuestionChange}
                        />
                      </Form.Group>
                    </FormProvider>
                  </Row>
                  {error && <p>{error}</p>}
                  {isQuestionSelected && (
                    <Row>
                      <div className="survey-engagement-barchart">
                        {selectedSurveyQuestionResponseDetails &&
                        selectedSurveyQuestionResponseDetails?.length > 0 ? (
                          <ESBarGraph
                            title="Employee Engagement Survey"
                            data={selectedSurveyQuestionResponseDetails}
                          />
                        ) : (
                          <p>Does not contain data</p>
                        )}
                      </div>
                    </Row>
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
